import * as React from 'react';
export const globeSvg = React.forwardRef(function globeSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M3.25 5.502a4.749 4.749 0 1 1 9.5 0A4.747 4.747 0 0 1 8 10.244a4.74 4.74 0 0 1-4.75-4.742ZM8 2.248A3.25 3.25 0 0 0 4.75 5.5 3.241 3.241 0 0 0 8 8.745a3.247 3.247 0 0 0 3.25-3.243A3.256 3.256 0 0 0 8 2.248Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.224.22a.75.75 0 0 1 1.061 0A7.49 7.49 0 0 1 15.5 5.525c0 3.88-2.97 7.063-6.75 7.43v1.535h1.75a.75.75 0 1 1 0 1.499h-5a.75.75 0 1 1 0-1.5h1.75v-1.536a7.434 7.434 0 0 1-4.53-2.151.75.75 0 1 1 1.06-1.061 5.94 5.94 0 0 0 4.238 1.75c3.298 0 5.982-2.67 5.982-5.966a5.99 5.99 0 0 0-1.775-4.246.75.75 0 0 1 0-1.06Z',
    }),
  );
});
globeSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var globe = {
  category: 'icon',
  colorable: true,
  name: 'globe',
  svg: globeSvg,
};
